import HighlightedArticles from './HighlightedArticles';

export default HighlightedArticles;
